import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary';
import LandingPage from 'pages/LandingPage';
import Error from 'pages/Error';

import { UnleashProvider } from 'providers/UnleashProvider';
import { ThemeProvider } from 'providers/ThemeProvider';

import initalization from './setup';

function AppBoot() {
  useEffect(() => {
    document.title = 'Wellhub';

    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.href = '/favicon.ico';
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:hash" element={<LandingPage />} />
        <Route path="/*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  initalization();

  return (
    <UnleashProvider>
      <ThemeProvider>
        <ErrorBoundary fallback={<Error />}>
          <AppBoot />
        </ErrorBoundary>
      </ThemeProvider>
    </UnleashProvider>
  );
}

export default App;
